var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formattedValue),expression:"formattedValue"}],ref:"inputRef",staticClass:"form-control",attrs:{"outlined":""},domProps:{"value":(_vm.formattedValue)},on:{"input":function($event){if($event.target.composing)return;_vm.formattedValue=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }